const TESTIMONIALS = [
    {
    id: 1,
    name: 'Derek Moore',
    position: 'Owner',
    website: '//www.cordovaflow.com',
    organization: 'Cordova Flow Controls, LLC',
    testimonial: '"At Cordova Flow Controls, we have worked with Abe on \
    many custom projects over the last decade and always with great success. \
    His ability to listen to our requirements and transform them into \
    complete products has been outstanding. The level of professionalism \
    and thoroughness is unmatched in the arena that we are in, and we \
    always trust and look forward to working with Abe and his team as we \
    are highly confident in the design, function, and durability of their \
    work with our projects."'
    }
]

export default TESTIMONIALS;